import { TextValue } from "../../tableElements";
import HighlightTextValue from "@/components/tableElements/HighlightTextValue.vue";
import { WrapWithSectionItem } from "../sections";
export default {
  name: "CampaignGroupFilterItem",
  emits: ["select", "selectOnly", "deselect"],
  props: {
    name: String,
    id: String,
    selected: Boolean,
    // Search term to highlight within the label.
    query: {
      type: String,
      default: ""
    }
  },
  components: {
    WrapWithSectionItem,
    TextValue,
    HighlightTextValue
  }
};